import styled, { css } from 'styled-components';

import { ReactComponent as ValidatorIcon } from '@components/web/src/assets/icons/validator.svg';
import { CaretDownIcon as RawCaretDownIcon } from '@components/web/src/atoms/Icons/CaretDownIcon';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { COLORS, RETAILER_COLORS, SHADOWS } from '@components/web/src/styles';

export const ContentWrapper = styled(Flexbox)`
  gap: 40px;
  padding: 16px;

  ${({ theme }) =>
    theme?.isKioskRootElementType &&
    css`
      gap: 64px;
      padding: 32px;
    `};
`;

export const ScannerWrapper = styled.div`
  position: relative;

  div {
    svg {
      // to hide default validator svg
      display: none;
    }

    video {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      background-color: rgb(0 0 0 / 5%);
    }
  }

  ${({ theme }) =>
    theme?.isKioskRootElementType &&
    css`
      width: 752px;
      height: 729px;
      margin: 259px auto 0;
    `};
`;

export const CustomValidatorIcon = styled(ValidatorIcon)<{ $isError: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  path {
    stroke: ${({ $isError }) => ($isError ? COLORS.base.red : COLORS.base.white)};
  }
`;

export const BannerWrapper = styled(Flexbox)`
  padding: 24px 14px 24px 0;
  margin-top: auto;
  border-radius: 16px 16px 0px 0px;
  background-color: ${RETAILER_COLORS.primary['50']};

  ${({ theme }) =>
    theme?.isKioskRootElementType &&
    css`
      padding: 32px 32px 32px 0;
      gap: 32px;
    `};
`;

export const ProductImage = styled.img`
  width: 102px;
  height: 102px;

  ${({ theme }) =>
    theme?.isKioskRootElementType &&
    css`
      width: 200px;
      height: 200px;
    `};
`;

export const CameraOptionWrapper = styled.div`
  position: relative;
`;

export const SelectedCameraOption = styled(Flexbox)`
  position: relative;
  width: 100%;
  background-color: transparent;
  border-radius: 0 0 4px 4px;
  z-index: 1;
  cursor: pointer;
  user-select: none;
`;

export const DropdownCameraOption = styled(Flexbox)`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: ${RETAILER_COLORS.secondary['50']};
  box-shadow: ${SHADOWS.md};
  border-radius: 0 0 4px 4px;
  z-index: 0;
  cursor: pointer;
  user-select: none;
`;

export const CaretDownIcon = styled(RawCaretDownIcon)<{ $isOpen: boolean }>`
  transition: transform 0.2s ease;
  transform: rotate(${props => (props.$isOpen ? '180deg' : '0deg')});
`;
